import React from 'react'
import PropTypes from 'prop-types'
import { CALENDAR_POPOVER_SELECTOR } from '../../constants/Constants'

const setDropdownItems = next => state => {
  return {
    dropdownItems: {
      ...state.dropdownItems,
      ...next
    }
  }
}

const withStateSOPQ = Component => {
  return class extends React.Component {
    static propTypes = {
      calendarOpen: PropTypes.bool,
      type: PropTypes.string,
      travelerDropdownOpen: PropTypes.bool,
      handleTripTypeChange: PropTypes.func,
      handleTravelerChange: PropTypes.func,
      handleTypeahead: PropTypes.func
    }
    static defaultProps = {
      tripType: 'round-trip',
      adultsCount: 1,
      youthsCount: 0,
      childrenCount: 0,
      infantsCount: 0,
      cabinClass: 'Economy',
      cabinClasses: ['Economy', 'Premium Economy', 'Business', 'First'],
      openSOPQCalendar: openSOPQCalendar,
      closeSOPQCalendar: closeSOPQCalendar,
      closeSOPQTravelerDropdown: closeSOPQTravelerDropdown,
      openSOPQTravelerDropdown: openSOPQTravelerDropdown,
      dropdownItems: [],
      handleTripTypeChange: () => {},
      handleTravelerChange: () => {}
    }

    constructor (props) {
      super(props)

      this.state = {
        ...props,
        calendarOpen: props.calendarOpen,
        travelerDropdownOpen: props.travelerDropdownOpen || false
      }

      this.handleChange = next => {
        this.setState(next)

        if (next.tripType) {
          this.props.handleTripTypeChange(next.tripType)
        }
      }

      this.handleTravelerChange = data => {
        const travelerTypeDictionary = {
          ADULTS: 'adultsCount',
          YOUTHS: 'youthsCount',
          CHILDREN: 'childrenCount',
          LAP_INFANTS: 'infantsCount'
        }

        const stateKey = travelerTypeDictionary[data.travelerType]
        const newTravelerState = {}
        const isNewCountNumber = typeof data.count === 'number'

        this.props.handleTravelerChange(data)

        newTravelerState[stateKey] = isNewCountNumber
          ? data.count
          : this.state[stateKey]
        this.setState(newTravelerState)
      }

      this.handleFlightChange = next => {
        const key = Object.keys(next)
        const currentQuery = next[key]

        this.props
          .handleTypeahead(currentQuery)
          .then(data => {
            if (data && Array.isArray(data)) {
              data.map((item, idx) => {
                data[idx].content = item.itemName
              })

              this.setState(setDropdownItems({ [key]: data }))
            }
          })
          .catch(err => {
            // TODO: add logging
            console.warn('Error fetching typeahead: ', err)
          })
      }

      this.handleCalendarChange = options => {
        const areBothDatesAvail =
          options.dates.startDate && options.dates.endDate

        if (!options.isOneWay) {
          this.handleChange({
            departureDate: options.dates.startDate,
            arrivalDate: options.dates.endDate
          })
        }

        if (options.isOneWay) {
          this.handleChange({
            departureDate: options.dates.startDate
          })
        }

        if (options.isOneWay || areBothDatesAvail) {
          this.update(closeSOPQCalendar)
        }
      }

      this.handleTypeaheadSelection = (key, item) => {
        this.setState({ [key]: item })
      }

      this.update = (...args) => {
        this.setState(...args)
      }

      this.handleDocumentClick = e => {
        if (e.target.closest('[data-calendar]') || e.target.closest(CALENDAR_POPOVER_SELECTOR)) return
        this.update(closeSOPQCalendar)
        this.update(closeSOPQTravelerDropdown)
      }
    }

    render () {
      return (
        <Component
          {...this.state}
          onChange={this.handleChange}
          onFlightChange={this.handleFlightChange}
          onTravelerChange={this.handleTravelerChange}
          onTypeaheadSelection={this.handleTypeaheadSelection}
          update={this.update}
          handleCalendarChange={this.handleCalendarChange}
          handleKeyup={this.handleKeyup}
          handleDocumentClick={this.handleDocumentClick}
        />
      )
    }
  }
}

export const openSOPQ = key => state => ({ [key]: true })
export const closeSOPQ = key => state => ({ [key]: false })
export const openSOPQTravelerDropdown = openSOPQ('travelerDropdownOpen')
export const closeSOPQTravelerDropdown = closeSOPQ('travelerDropdownOpen')
export const openSOPQCalendar = () => ({ calendarOpen: true })
export const closeSOPQCalendar = () => ({ calendarOpen: false })

export default withStateSOPQ
